// Navbar.jsx
// Beyaz, yapışkan üst menü: logo, ana bağlantılar, TR/EN dil seçici, giriş. 1100px altında
// hamburger menüye dönüşür. Dil seçici, aynı sayfanın diğer dildeki adresine götürür.

import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import AuthControls from './AuthControls';
import { alternatePath, useLang } from '../i18n';

const LINKS = ['play', 'puzzles', 'arena', 'howto', 'pieces', 'rules', 'academy', 'leaderboard'];

export function LangSwitch() {
  const { pathname } = useLocation();
  const { lang, t } = useLang();
  return (
    <nav className="lang-switch" aria-label={t('nav.language')}>
      <Link to={alternatePath(pathname, 'tr')} hrefLang="tr" lang="tr" className={lang === 'tr' ? 'active' : ''}>
        TR
      </Link>
      <Link to={alternatePath(pathname, 'en')} hrefLang="en" lang="en" className={lang === 'en' ? 'active' : ''}>
        EN
      </Link>
    </nav>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { t, to } = useLang();

  useEffect(() => setOpen(false), [pathname]);

  const linkClass = ({ isActive }) => 'nav-item-link' + (isActive ? ' active' : '');
  const links = LINKS.map((key) => (
    <NavLink key={key} to={to(key)} className={linkClass} end={key === 'puzzles' ? false : true}>
      {t(`nav.${key}`)}
    </NavLink>
  ));

  return (
    <header className="site-header">
      <div className="container">
        <div className="bar">
          <Link to={to('home')} className="brand" aria-label={t('brand')}>
            <span className="brand-mark jp" aria-hidden="true">将</span>
            <span>
              <span className="brand-name">{t('brand')}</span>
              <span className="brand-tag">{t('brandTag')}</span>
            </span>
          </Link>

          <nav className="nav-main" aria-label="Ana menü">
            {links}
            <span className="ms-2"><LangSwitch /></span>
            <AuthControls />
          </nav>

          <button
            type="button"
            className="menu-toggle"
            aria-expanded={open}
            aria-controls="mobileMenu"
            aria-label={t('nav.menu')}
            onClick={() => setOpen((o) => !o)}
          >
            {open ? '✕' : '☰'}
          </button>
        </div>

        <div id="mobileMenu" className={`mobile-menu ${open ? 'open' : ''}`}>
          {links}
          <div className="d-flex align-items-center justify-content-between gap-2 pt-3 flex-wrap">
            <LangSwitch />
            <AuthControls onNavigate={() => setOpen(false)} />
          </div>
        </div>
      </div>
    </header>
  );
}
